import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSaving(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5358_6111)">
        <path d="M11.5 11.5V2.5L9.5 0.5H0.5V11.5H11.5Z" stroke="currentColor" />
        <path d="M2.5 11.5H9.5V6.5H2.5V11.5Z" stroke="currentColor" />
        <path d="M2.5 3.5H8.5V0.5H2.5V3.5Z" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_5358_6111">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
